import { render, staticRenderFns } from "./LoginFront.vue?vue&type=template&id=b04513ae&"
import script from "./LoginFront.vue?vue&type=script&lang=js&"
export * from "./LoginFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports